import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { SelectOption } from "../../../shared/interfaces/select-option";
import { ScoReportingService } from "../services/sco-reporting.service";

export const bankingTransactionTypesResolver: ResolveFn<SelectOption[]> = () => {
    const service = inject(ScoReportingService);
    return service.getTransactionTypes();
};
